"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerBiReportClient = void 0;
const BaseClient_1 = require("../BaseClient");
/**
 * @deprecated - use logi-reports library instead
 */
class PowerBiReportClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async getEmbedToken(reportId, allowEdit, partition, allowSaveAs) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/powerbi/reports/token',
            params: {
                reportId,
                allowEdit,
                allowSaveAs,
                partition,
            },
        });
        return response.data;
    }
    async refreshDataset(datasetId, partition) {
        await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/powerbi/reports/refreshDataset',
            params: {
                datasetId,
                partition,
            },
        });
    }
    async listReports(partition) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/powerbi/reports/list',
            params: {
                partition,
            },
        });
        return response.data;
    }
    async requestExport(exportRequest, reportId, partition) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/powerbi/reports/export',
            params: {
                reportId,
                partition,
            },
            data: exportRequest,
        });
        return response.data;
    }
    async getExportStatus(reportId, exportId, partition) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/powerbi/reports/export-status',
            params: {
                reportId,
                exportId,
                partition,
            },
        });
        return response.data;
    }
    getExportFileUrl(reportId, exportId, partition, downloadFileName) {
        const url = new URL(`${this.axiosInstance.defaults.baseURL}/api/v1/powerbi/reports/export-file`);
        url.searchParams.append('reportId', reportId);
        url.searchParams.append('exportId', exportId);
        if (partition) {
            url.searchParams.append('partition', partition);
        }
        if (downloadFileName) {
            url.searchParams.append('downloadFileName', downloadFileName);
        }
        return url.href;
    }
}
exports.PowerBiReportClient = PowerBiReportClient;
